import Client from "./client";

// The site admin panel - see api/routes/siteAdmin.js. Every call here needs
// a siteadmin account's own accessToken; the API refuses everyone else with
// a plain 403, which each of these surfaces as a normal rejected promise.

export const ListSiteAdminUsers = ({query, cursor, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get('/api/site-admin/users', {
            params: {query: query || undefined, cursor: cursor || undefined},
            headers: {Authorization: `Bearer ${accessToken}`},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || {error: "Something went wrong loading users."});
        })
    })
}

export const GetSiteAdminUserProjects = ({userId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/site-admin/users/${userId}/projects`, {
            headers: {Authorization: `Bearer ${accessToken}`},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || {error: "Something went wrong loading that account's projects."});
        })
    })
}

export const GetSiteAdminMetrics = (accessToken) => {
    return new Promise((resolve, reject) => {
        Client.get('/api/site-admin/metrics', {
            headers: {Authorization: `Bearer ${accessToken}`},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || {error: "Something went wrong loading metrics."});
        })
    })
}

export const GetSiteAdminOverLimit = (accessToken) => {
    return new Promise((resolve, reject) => {
        Client.get('/api/site-admin/over-limit', {
            headers: {Authorization: `Bearer ${accessToken}`},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || {error: "Something went wrong loading the over-limit report."});
        })
    })
}

export const GetSiteAdminAnalytics = (accessToken) => {
    return new Promise((resolve, reject) => {
        Client.get('/api/site-admin/analytics', {
            headers: {Authorization: `Bearer ${accessToken}`},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || {error: "Something went wrong loading analytics."});
        })
    })
}

export const ListSiteAdminPlans = (accessToken) => {
    return new Promise((resolve, reject) => {
        Client.get('/api/site-admin/plans', {
            headers: {Authorization: `Bearer ${accessToken}`},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || {error: "Something went wrong loading plans."});
        })
    })
}

// planCode is a real Plan.code, or "STARTER" to drop the account back to no
// subscription. currentPeriodEnd is an ISO date string, or null to clear it;
// leave the key out entirely to leave the current end date alone.
export const ChangeSiteAdminUserPlan = ({userId, planCode, currentPeriodEnd, accessToken}) => {
    return new Promise((resolve, reject) => {
        const body = {};
        if (planCode !== undefined) body.planCode = planCode;
        if (currentPeriodEnd !== undefined) body.currentPeriodEnd = currentPeriodEnd;

        Client.put(`/api/site-admin/users/${userId}/plan`, body, {
            headers: {Authorization: `Bearer ${accessToken}`},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || {error: "Something went wrong changing that account's plan."});
        })
    })
}

// status is one of "CONFIRMED" (reinstate), "BANNED", or "DELETED".
export const ChangeSiteAdminUserStatus = ({userId, status, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/site-admin/users/${userId}/status`, {status}, {
            headers: {Authorization: `Bearer ${accessToken}`},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || {error: "Something went wrong changing that account's status."});
        })
    })
}
